import React from 'react';
import FamilyCardRo from './FamilyCardRo';

const body = [
  'Linia Rivera-Mwangi culminează la marginea cea mai îndepărtată a civilizației umane. <strong class="text-white">Eseosa Rivera-Mwangi</strong>, Directoarea Observatorului Heliopausei din Neptun, a fost primul om de știință care a detectat semnalul din spațiul interstelar profund — la unsprezece zile după ce fiica ei Imogen a plecat la bordul Odiseei ca navigator al treilea schimb spre Alpha Centauri.',
  'Această familie a stat, generație după generație, la granița dintre cunoscut și necunoscut. Erau observatori, răbdători și deliberați, întruchipând cultura neptuniană a <strong class="text-white">atenției susținute</strong>.',
  'Când cronica se termină, este prin ochii lor: o mamă la observatorul ei, o fiică îndreptată spre stele, un semnal în întuneric.',
];

const FamilyRiveraRo = () => (
  <FamilyCardRo
    id="family-ro-3"
    accentColor="text-blue-400"
    dotColor="bg-blue-400"
    borderColor="border-blue-500/20"
    bgGlow="bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-blue-900/10 via-transparent to-transparent"
    tag="Santinelele de la Margine · Neptun / Interstelar"
    name="Familia Rivera-Mwangi"
    origin="Neptun · Stația Triton · Interstelar"
    body={body}
    quote="Mergi bine. Suntem aici. Vom fi aici când te vei întoarce."
    quoteSource="Eseosa Rivera-Mwangi, fiicei sale Imogen, 14 martie 2514"
  />
);

export default FamilyRiveraRo;